<template>
  <div v-if="ready">
    <!-- <draggable
      :list="questions"
      :options="groupOptions"
      element="q-list"
      class="q-pa-md q-pb-lg drag-list"
      @start="dragging=true"
      @end="dragging=false"
      @sort="handleSort"
      dense
      separator
    >-->
    <div class="row q-mb-md">
      <div class="col-sm-12">
        <q-btn push icon="add" label="Add Question" color="primary" @click="addQuestion"/>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <draggable
          v-model="questions"
          :options="groupOptions"
          element="q-list"
          class="q-pa-md q-pb-lg drag-list"
          @start="dragging=true"
          @end="dragging=false"
          @sort="handleQuestionSort"
          dense
          separator
        >
          <template v-for="(question, index) in questions">
            <q-item
              :key="question.sort"
              v-if="!question.delete && !question.removalDate"
              multiline
              highlight
              class="sorting items-center handle"
            >
              <q-item-side>
                <q-btn
                  flat
                  round
                  dense
                  icon="edit"
                  text-color="primary"
                  :disabled="loading"
                  @click="editQuestion(index)"
                  class="q-mr-sm"
                />
                <q-btn
                  flat
                  round
                  dense
                  icon="delete"
                  color="negative"
                  :disabled="loading"
                  @click="removeQuestion(index)"
                />
              </q-item-side>
              <q-item-main :class="[dragging ? 'moving' : '']" class>
                <!-- <span>{{question.questionText}}</span> -->
                <q-item-tile label>{{ question.questionText }}</q-item-tile>
                <q-item-tile sublabel>{{ question.questionType | questionTypeDisplay }}</q-item-tile>
              </q-item-main>
              <q-item-side right class>
                <q-icon flat round dense name="drag_handle" color="secondary"></q-icon>
              </q-item-side>
            </q-item>
          </template>
        </draggable>
        <q-modal
          v-model="questionModalOpen"
          content-classes="q-pa-lg"
          content-css="min-width: 70%"
          no-route-dismiss
          no-esc-dismiss
          no-backdrop-dismiss
        >
          <div class="fit">
            <q-btn
              flat
              icon="close"
              class
              style="top: 0; right: 0; position: relative; float: right"
              @click="questionModalOpen=false"
            ></q-btn>
            <div>
              <h4>Question Editor/Creator</h4>
              <div class="mdi-card full-width q-pa-md">
                <form @submit.prevent="saveQuestion">
                  <div class="row">
                    <!-- ROW 1 -->
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <q-field
                        orientation="vertical"
                        label="Question"
                        class="q-pa-md"
                        inset="full"
                        :icon="errors.has('questionText', validatorFormName) ? 'star_border' : 'star'"
                        :icon-color="errors.has('questionText', validatorFormName) ? 'negative' : 'blue-5'"
                        :class="{'is-required': errors.has('questionText', validatorFormName)}"
                        :error="errors.has('questionText', validatorFormName)"
                        :error-label="errors.first('questionText', validatorFormName)"
                        helper="Question to the registrant"
                      >
                        <q-input
                          v-validate="'required'"
                          data-vv-name="questionText"
                          v-model="questionForm.questionText"
                          type="text"
                          name="questionText"
                          class="no-shadow"
                          hide-underline
                          inverted-light
                          :color="errors.has('questionText') ? 'negative' : inputBgColor"
                          :validator-form-name="validatorFormName"
                          :data-vv-scope="validatorFormName"
                        />
                      </q-field>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <q-field
                        orientation="vertical"
                        label="Invoice Description"
                        class="q-pa-md"
                        inset="full"
                        :icon="errors.has('invoiceDesc', validatorFormName) ? 'star_border' : 'star'"
                        :icon-color="errors.has('invoiceDesc', validatorFormName) ? 'negative' : 'blue-5'"
                        :class="{'is-required': errors.has('invoiceDesc', validatorFormName)}"
                        :error="errors.has('invoiceDesc', validatorFormName)"
                        :error-label="errors.first('invoiceDesc', validatorFormName)"
                        helper="Description seen on Invoice"
                      >
                        <q-input
                          v-validate="'required'"
                          data-vv-name="invoiceDesc"
                          v-model="questionForm.invoiceDesc"
                          type="text"
                          name="invoiceDesc"
                          class="no-shadow"
                          hide-underline
                          inverted-light
                          :color="errors.has('invoiceDesc') ? 'negative' : inputBgColor"
                          :validator-form-name="validatorFormName"
                          :data-vv-scope="validatorFormName"
                        />
                      </q-field>
                    </div>
                  </div>
                  <div class="row">
                    <!-- ROW 2 -->
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <q-field
                        orientation="vertical"
                        label="Require Question"
                        class="q-pa-md"
                        inset="full"
                        icon="edit"
                        :icon-color="inputBgColor"
                        helper="Require registrant to answer question"
                      >
                        <q-toggle v-model="questionForm.required" label="Yes" name="required"/>
                      </q-field>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <q-field
                        orientation="vertical"
                        label="Hide Question"
                        class="q-pa-md"
                        inset="full"
                        icon="edit"
                        :icon-color="inputBgColor"
                        helper="Hide the question from the regisration form"
                      >
                        <q-toggle v-model="questionForm.hidden" label="Yes" name="hidden"/>
                      </q-field>
                    </div>
                  </div>
                  <div class="row">
                    <!-- ROW 3 -->
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <q-field
                        orientation="vertical"
                        label="Apply Question to All Attendees"
                        class="q-pa-md"
                        inset="full"
                        icon="edit"
                        :icon-color="inputBgColor"
                        helper="Question will be presented to primary registrant and all additional attendees"
                      >
                        <q-toggle
                          v-model="questionForm.appliesToAll"
                          label="Yes"
                          name="appliesToAll"
                        />
                      </q-field>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <q-field
                        orientation="vertical"
                        label="Show for Not Attending"
                        class="q-pa-md"
                        inset="full"
                        icon="edit"
                        :icon-color="inputBgColor"
                        helper="If the registrant is not attending, but you still want them to see this question question, check this."
                      >
                        <q-toggle
                          v-model="questionForm.showForNotAttending"
                          label="Yes"
                          name="appliesToAll"
                        />
                      </q-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-12">
                      <q-field
                        orientation="vertical"
                        label="Question Type"
                        class="q-pa-md"
                        inset="full"
                        :icon="errors.has('questionType', validatorFormName) ? 'star_border' : 'star'"
                        :icon-color="errors.has('questionType', validatorFormName) ? 'negative' : 'blue-5'"
                        :class="{'is-required': errors.has('questionType', validatorFormName)}"
                        :error="errors.has('questionType', validatorFormName)"
                        :error-label="errors.first('questionType', validatorFormName)"
                      >
                        <q-select
                          v-model="questionForm.questionType"
                          :options="questionTypeOptions"
                          v-validate="'required'"
                          data-vv-name="questionType"
                          name="questionType"
                          class="no-shadow"
                          hide-underline
                          inverted-light
                          :color="errors.has('questionType') ? 'negative' : inputBgColor"
                          :validator-form-name="validatorFormName"
                          :data-vv-scope="validatorFormName"
                        />
                      </q-field>
                    </div>
                  </div>
                  <div class="row" v-if="questionForm.questionType === 'bool'">
                    <!-- ROW 3 BOOL -->
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <q-field
                        orientation="vertical"
                        label="Cost Modifier"
                        class="q-pa-md"
                        inset="full"
                        icon="edit"
                        :icon-color="inputBgColor"
                        helper="Checking yes to this question affects price by (can be positive or negative number)"
                      >
                        <q-input
                          v-validate="'required'"
                          v-model="questionForm.costModifier"
                          type="number"
                          name="costModifier"
                          :decimals="2"
                          prefix="$"
                          class="no-shadow"
                          hide-underline
                          inverted-light
                          :color="inputBgColor"
                        />
                      </q-field>
                    </div>
                  </div>
                  <!-- ROW 4 SELECT -->
                  <div class="row q-mb-md" v-if="questionForm.questionType === 'select'">
                    <div class="col-sm-12">
                      <q-btn
                        push
                        icon="add"
                        label="Add Select Option"
                        color="primary"
                        @click="addOption"
                      />
                    </div>
                  </div>
                  <div class="row" v-if="questionForm.questionType === 'select'">
                    <div class="col-sm-12">
                      <draggable
                        v-if="questionForm.questionOption"
                        v-model="questionForm.questionOption"
                        :options="groupOptions"
                        element="q-list"
                        class="q-pa-md q-pb-lg drag-list"
                        @start="dragging=true"
                        @end="dragging=false"
                        @sort="handleOptionSort"
                        dense
                        separator
                      >
                        <template v-for="(option, index) in questionForm.questionOption">
                          <q-item
                            :key="option.id"
                            multiline
                            class="sorting items-center handle"
                            :id="option.id"
                            v-if="!option.delete && !option.removalDate"
                          >
                            <q-item-side>
                              <q-btn
                                flat
                                round
                                dense
                                icon="edit"
                                text-color="primary"
                                :disabled="loading"
                                @click="editOption(index)"
                                class="q-mr-sm"
                              />
                              <q-btn
                                flat
                                round
                                dense
                                icon="delete"
                                color="negative"
                                :disabled="loading"
                                @click="removeOption(index)"
                              />
                            </q-item-side>
                            <q-item-main :class="[dragging ? 'moving' : '']" class>
                              <span>{{option.optionText}}</span>
                            </q-item-main>
                            <q-item-side right class>
                              <q-icon flat round dense name="drag_handle" color="secondary"></q-icon>
                            </q-item-side>
                          </q-item>
                        </template>
                      </draggable>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <q-btn
                        color="primary"
                        @click="saveQuestion"
                        class="full-width"
                        push
                        size="lg"
                        :disabled="false"
                      >Save</q-btn>
                    </div>
                  </div>
                </form>
              </div>
              <q-btn
                class="q-mt-lg"
                color="primary"
                @click="questionModalOpen = false"
                label="Close"
              />
            </div>
          </div>
        </q-modal>
        <!-- OPTION MODAL -->
        <q-modal
          v-model="optionModalOpen"
          content-classes="q-pa-lg"
          content-css="min-width: 60%"
          no-route-dismiss
          no-esc-dismiss
          no-backdrop-dismiss
        >
          <div class="fit">
            <q-btn
              flat
              icon="close"
              class
              style="top: 0; right: 0; position: relative; float: right"
              @click="optionModalOpen=false"
            ></q-btn>
            <div>
              <h4>Select Option Editor/Creator</h4>
              <div class="mdi-card full-width q-pa-md">
                <form @submit.prevent="saveOption">
                  <!-- ROW 4 SELECT -->
                  <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <q-field
                        orientation="vertical"
                        label="Option Name"
                        class="q-pa-md"
                        inset="full"
                        :icon="errors.has('optionText', validatorOptionFormName) ? 'star_border' : 'star'"
                        :icon-color="errors.has('optionText', validatorOptionFormName) ? 'negative' : 'blue-5'"
                        :class="{'is-required': errors.has('optionText', validatorOptionFormName)}"
                        :error="errors.has('optionText', validatorOptionFormName)"
                        :error-label="errors.first('optionText', validatorOptionFormName)"
                        helper="Select option text representation"
                      >
                        <q-input
                          v-validate="'required'"
                          data-vv-name="optionText"
                          v-model="optionForm.optionText"
                          type="text"
                          name="optionText"
                          class="no-shadow"
                          hide-underline
                          inverted-light
                          :color="errors.has('optionText') ? 'negative' : inputBgColor"
                          :validator-form-name="validatorOptionFormName"
                          :data-vv-scope="validatorOptionFormName"
                        />
                      </q-field>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <q-field
                        orientation="vertical"
                        label="Hide Option"
                        class="q-pa-md"
                        inset="full"
                        icon="edit"
                        :icon-color="inputBgColor"
                        helper="Hide the question from the regisration form"
                      >
                        <q-toggle v-model="optionForm.hidden" label="Yes" name="hidden"/>
                      </q-field>
                    </div>
                  </div>
                  <div class="row">
                    <!-- ROW 5 SELECT -->
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <q-field
                        orientation="vertical"
                        label="Cost Modifier"
                        class="q-pa-md"
                        inset="full"
                        icon="edit"
                        :icon-color="inputBgColor"
                        helper="Checking yes to this question affects price by (can be positive or negative number)"
                      >
                        <q-input
                          v-validate="'required'"
                          v-model="optionForm.costModifier"
                          type="number"
                          name="costModifier"
                          :decimals="2"
                          prefix="$"
                          class="no-shadow"
                          hide-underline
                          inverted-light
                          :color="inputBgColor"
                        />
                      </q-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <q-btn
                        color="primary"
                        @click="saveOption"
                        class="full-width"
                        push
                        size="lg"
                        :disabled="false"
                      >Save</q-btn>
                    </div>
                  </div>
                </form>
              </div>
              <q-btn
                class="q-mt-lg"
                color="primary"
                @click="optionModalOpen = false"
                label="Close"
              />
            </div>
          </div>
        </q-modal>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import colorsMixin from '../../mixins/colors'
import { extend } from 'quasar'
// import Vue from 'vue'

export default {
  name: 'CustomQuestions',
  inject: ['$validator'],
  mixins: [colorsMixin],
  components: {
    draggable
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
    // value: {
    //   type: String,
    //   default: ''
    // }
  },
  data () {
    return {
      qbCustomerId: undefined,
      questionModalOpen: false,
      optionModalOpen: false,
      ready: false,
      loading: true,
      dragging: false,
      serverData: [],
      questions: [],
      groupOptions: {
        group: 'root',
        sort: true,
        disabled: false,
        animation: 50,
        handle: '.handle',
        ghostClass: 'ghosting'
      },
      questionTypeOptions: [
        {
          label: 'Open Text',
          value: 'text'
        },
        {
          label: 'Select',
          value: 'select'
        },
        {
          label: 'Yes / No',
          value: 'bool'
        },
        {
          label: 'Address',
          value: 'address'
        }
      ],
      validatorFormName: 'question',
      validatorOptionFormName: 'option',
      questionForm: {},
      optionForm: {},
      questionFormIndex: {},
      optionFormIndex: {},
      blankQuestion: {
        // id: null,
        event: null,
        hidden: false,
        required: false,
        appliesToAll: false,
        showForNotAttending: false,
        questionType: 'text',
        questionText: 'New Question',
        invoiceDesc: 'Unique Description',
        costModifier: null,
        sort: 0,
        removalDate: null,
        questionOption: []
      },
      blankQuestionOption: {
        // id: null,
        questionId: 0,
        hidden: false,
        optionText: 'New Option',
        optionValue: '',
        costModifier: null,
        sort: 0,
        removalDate: null
      }
    }
  },
  filters: {
    questionTypeDisplay (val) {
      if (val === 'text') {
        return 'Open Text'
      } else if (val === 'select') {
        return 'Select'
      } else if (val === 'bool') {
        return 'Yes / No'
      } else if (val === 'address') {
        return 'Address'
      }
    }
  },
  computed: {
    eventId () {
      if (this.$route && this.$route.params && this.$route.params.id) {
        return parseInt(this.$route.params.id)
      }
      return false
    }
  },
  methods: {
    // QUESTIONS
    addQuestion () {
      let blankQuestion = extend(false, this.blankQuestion)
      this.questions.push(blankQuestion)
      this.handleQuestionSort()
    },
    removeQuestion (index) {
      this.$q
        .dialog({
          title: 'Confirm Delete of Question',
          message: `Are you sure you want to remove this question: "${this.questions[index].questionText}"`,
          ok: {
            label: 'Delete',
            color: 'negative'
          },
          cancel: true
        })
        .then(() => {
          // this.questions[index].delete = true
          // this.$delete(this.questions, index)
          this.$set(this.questions[index], 'delete', true)
          this.handleUpdate()
        })
        .catch(() => {})
    },
    editQuestion (index) {
      this.questionForm = extend(false, this.questions[index])
      this.questionFormIndex = index
      this.orderOptions()
      this.questionModalOpen = true
    },
    handleQuestionSort () {
      if (this.questions && this.questions.length > 0) {
        let sorted = this.questions.map((value, index) => {
          if (value.sort >= 0) {
            value.sort = index
          }
          return value
        })
        this.questions = sorted
      }
      this.handleUpdate()
    },
    async saveQuestion () {
      const result = await this.$validator.validate(this.validatorFormName + '.*')
      if (!result) {
        this.$q.notify({
          message: 'Please complete all required fields',
          type: 'negative'
        })
        return
      }
      const invoiceDescriptions = this.value.filter((v, index) => v.invoiceDesc === this.questionForm.invoiceDesc && index !== this.questionFormIndex)
      if (invoiceDescriptions.length) {
        this.$q.notify({
          message: 'Invoice Description is the same as another.  These must be unique.',
          type: 'negative'
        })
        return
      }
      this.questions[this.questionFormIndex] = this.questionForm
      this.questionModalOpen = false
      this.handleUpdate()
    },
    // OPTIONS
    addOption () {
      let blankQuestionOption = extend(false, this.blankQuestionOption)
      this.questionForm.questionOption.push(blankQuestionOption)
      this.handleOptionSort()
    },
    removeOption (index) {
      this.$q
        .dialog({
          title: 'Confirm Delete of Question',
          message: `Are you sure you want to remove this question: "${this.questionForm.questionOption[index].optionText}"`,
          ok: {
            label: 'Delete',
            color: 'negative'
          },
          cancel: true
        })
        .then(() => {
          // this.$delete(this.questionForm.questionOption, index)
          // this.questionForm.questionOption[index].delete = true
          this.$set(this.questionForm.questionOption[index], 'delete', true)
        })
        .catch(() => {})
    },
    editOption (index) {
      this.optionForm = extend(false, this.questionForm.questionOption[index])
      this.optionFormIndex = index
      this.optionModalOpen = true
    },
    orderOptions () {
      if (this.questionForm && this.questionForm.questionOption && this.questionForm.questionOption.length > 0) {
        let sorted = this.questionForm.questionOption
        sorted.sort((a, b) => a.sort - b.sort)
        this.questionForm.questionOption = sorted
      }
    },
    handleOptionSort () {
      if (this.questionForm && this.questionForm.questionOption && this.questionForm.questionOption.length > 0) {
        let sorted = this.questionForm.questionOption.map((value, index) => {
          if (value.sort >= 0) {
            value.sort = index
          }
          return value
        })
        console.log('sorted options', sorted)
        this.questionForm.questionOption = sorted
      }
    },
    async saveOption () {
      const result = await this.$validator.validate(this.validatorOptionFormName + '.*')
      if (!result) {
        this.$q.notify({
          message: 'Please complete all required fields',
          type: 'negative'
        })
        return
      }
      this.questionForm.questionOption[this.optionFormIndex] = this.optionForm
      this.optionModalOpen = false
    },
    // OTHER METHODS
    async handleUpdate () {
      // this.$root.$emit('update-form', 'grades', this.xhrData)
      this.$emit('manual-update', 'question', this.questions)
    },
    async request () {
      if (this.value && this.value.length > 0) {
        // console.log('have value', this.value)
        this.questions = [...this.value.sort((a, b) => a.sort - b.sort)]
        // this.handleQuestionSort()
      } else if (this.eventId) {
        // console.log('get value')
        this.loading = true
        const config = {
          params: {
            $filter: `eventId eq ${this.eventId}`,
            $expand: `questionOption`,
            $orderby: `sort asc`
          }
        }
        try {
          const { data } = await this.$axios.get('/api/odata/question/paginate', config)
          if (data) {
            this.questions = data.data
            this.loading = false
          } else {
            this.$q.notify({
              message: 'Error fetching Person Records 1'
            })
            this.ready = true
            this.loading = false
          }
        } catch (e) {
          this.$q.notify({
            message: 'Error fetching Person Records 2'
          })
          this.loading = false
        }
      }
      this.loading = false
      this.ready = true
    }
  },
  async mounted () {
    this.request()
  }
  // watch: {
  //   value: {
  //     handler (newValue) {
  //       this.$set(this, 'question', newValue)
  //     },
  //     immediate: true
  //   }
  // }
}
</script>
